import { DesignToken as a } from "@matrix42/fast-foundation";
import { applyTheme as i } from "./theme/apply-theme.js";
import { defaultDesignSystemConfig as r } from "./config.js";
import { registerComponents as f } from "./component-registration.js";
function y(n) {
  const t = {
    ...r,
    ...n
  };
  typeof t.theme == "string" && l(t), i(t.theme, t.themeMode, t.htmlFontSize), a.registerDefaultStyleTarget(
    t.root instanceof Document ? t.root : t.root.style
  ), f(t);
}
const s = "nova-ds-assets";
function l(n) {
  if (document.getElementById(s) != null)
    return;
  let e = n.assetsUrl;
  e.endsWith("/") && (e = e.slice(0, -1));
  const o = document.createElement("style");
  o.id = s, o.innerHTML = `
@font-face {
  font-family: "Open Sans";
  src: url("${e}/Open Sans/OpenSans-VariableFont_wdth,wght.ttf") format("woff2-variations");
  font-style: normal;
}
@font-face {
  font-family: "Open Sans";
  src: url("${e}/Open Sans/OpenSans-Italic-VariableFont_wdth,wght.ttf") format("woff2-variations");
  font-style: italic;
}
@font-face {
  font-family: "Fira Code";
  src: url("${e}/Fira Code/FiraCode-VariableFont_wght.ttf") format("woff2-variations");
  font-style: normal;
}
  `, (n.root instanceof Document ? document.documentElement : n.root).appendChild(o);
}
export {
  y as provideNovaDesignSystem
};
